import { mainApi } from '../../../../api/mainApi';
import { changeRememberTokenStorage } from '../../../auth/helpers';
import { middlewareApi } from '../../../middleware/middlewareApi';
import { ChangePasswordPayload, ChangePassword } from '../interfaces/changePassword.interface';
import { Languages } from '../../../../types';

// necesary if require tags
// export const configurationTags = middlewareApi.enhanceEndpoints({});

// Define a service using a base URL and expected endpoints
export const configurationsApi = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @POST change password
     */
    changePassword: builder.mutation<
      ChangePassword,
      { profileId: number; changePasswordPayload: Partial<ChangePasswordPayload> }
    >({
      queryFn: async ({ profileId, changePasswordPayload }, { dispatch }) => {
        try {
          const { data } = await mainApi.put<ChangePassword>('/profile/change-password', {
            user_profile_id: profileId,
            ...changePasswordPayload,
          });

          changeRememberTokenStorage(dispatch);

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      // invalidatesTags: [{ type: 'Config' }],
    }),

    /**
     * Change user language
     */
    changeLanguage: builder.mutation<any, { language: Languages }>({
      queryFn: async ({ language }) => {
        try {
          const { data } = await mainApi.put('/languages', {
            language,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useChangePasswordMutation, useChangeLanguageMutation } = configurationsApi;
